import React from "react";
import Icon from '@assets/tsx/icon/pickerIcon';
import { Link } from '@ambiguous/link';
export default function CardListIcon({ title, column_count, underscored, bg_color, card_bg_color, cards }) {
    const bg_styles = bg_color ? { style: { backgroundColor: bg_color } } : null;
    return (React.createElement("div", { className: `ltg-card-list-icon` },
        React.createElement("div", Object.assign({ className: `ltg-card` }, bg_styles),
            React.createElement("div", { className: "ltg-card-text-wrap" },
                React.createElement("div", { className: `ltg-card-text-content` },
                    React.createElement("h2", { role: "presentation", className: "ltg-card-title" },
                        React.createElement("span", { className: !!underscored ? 'ltg-card-underscored' : '' }, title)),
                    React.createElement(CardList, { cards: cards, bg: card_bg_color, colCount: column_count === null || column_count === void 0 ? void 0 : column_count.size }))))));
}
function CardList({ cards, bg, colCount }) {
    const bg_styles = bg ? { backgroundColor: bg } : null;
    return (React.createElement("div", { className: `ltg-card-list${!!colCount ? ` --col-count-${colCount}` : ''}` }, cards === null || cards === void 0 ? void 0 : cards.map(({ icon, url__props, title, url, _id }) => {
        return (React.createElement("div", { key: _id, className: "ltg-card-list-col" },
            React.createElement(ListItem, { url: url, blank: url__props === null || url__props === void 0 ? void 0 : url__props.blank, className: "ltg-card-list-item", style: bg_styles },
                (icon === null || icon === void 0 ? void 0 : icon.iconClassName) && (React.createElement("div", { className: "ltg-card-list-icon" },
                    React.createElement(Icon, Object.assign({}, icon)))),
                React.createElement("div", { className: `ltg-card-list-text${!!url ? ' --has-chevron' : ''}` },
                    title,
                    !!url && (React.createElement("span", { className: "ltg-card-list-chevron" },
                        React.createElement("i", { className: "fas fa-chevron-right" })))))));
    })));
}
function ListItem({ url, blank, className, children, style }) {
    if (url) {
        return (React.createElement(Link, { href: url, target: blank ? '_blank' : null, style: style, rel: blank ? 'noreferrer noopener nofollow' : null, className: className }, children));
    }
    return React.createElement("div", { style: style, className: className }, children);
}
